module.exports = __webpack_public_path__ + "img/gal_25.1e381e08.png";